// XXX The function parseURLParams is exported by the feature base/util (as
// defined in the terminology of react/). However, this file is (very likely)
// bundled in external_api in addition to app.bundle and, consequently, it is
// best to import as little as possible here (rather than the whole feature
// base/util) in order to minimize the amount of source code bundled into
// multiple bundles.
import { env } from '../../react/features/base/environment/utils';
import { parseURLParams } from '../../react/features/base/util/parseURLParams';
/**
 * ViettelMeetingExternalAPI id - unique for a webpage.
 * TODO: This shouldn't be computed here.
 */
let _apiID;
try {
    _apiID = parseURLParams(window.location).jitsi_meet_external_api_id;
}
catch (_) { /* Ignore. */ }
export const API_ID = _apiID;
/**
 * The payload name for the datachannel/endpoint text message event.
 */
export const ENDPOINT_TEXT_MESSAGE_NAME = 'endpoint-text-message';
/**
 * The min value that can be set for the assumed bandwidth.
 * Setting it to this value means not assuming any bandwidth,
 * but rather allowing the estimations to take place.
 */
export const MIN_ASSUMED_BANDWIDTH_BPS = -1;
/***************************************************************
 * DYNAMIC ENVIROMENT FOR AUTH, SOCKET AND WHITEBOARD
 ***************************************************************/
export const authDomain = env("AUTH_DOMAIN", "https://ops.viettelmeet.com");
const domain = `${authDomain}/`;
export const page = domain;
export const PAGE_AUTH = authDomain;
export const SOCKET_URL = authDomain;
export const DOMAIN_WHITEBOARD = env("WHITEBOARD_DOMAIN");
export const PATH_ROOT = env("PATH_ROOT") || "/";
export const DOMAIN_PREVIEW_WHITEBOARD = env("PREVIEW_WHITEBOARD_DOMAIN");
export const DOMAIN_MEETING = env("DOMAIN") || "https://testmeeting.atviettelsolutions.com";
export const COOKIES_TOKEN_KEY = env("COOKIES_TOKEN_KEY");
export const COOKIES_REFRESH_TOKEN_KEY = env("COOKIES_REFRESH_TOKEN_KEY");
export const LOCAL_GUEST_NAME = env("LOCAL_GUEST_NAME");
export const DEFAULT_SIP_SERVER = env("DEFAULT_SIP_SERVER");
export const LANDING_PAGE = env("LANDING_PAGE");
export const LINK_JITSIMEET = DOMAIN_MEETING;
export const LINK_JITSIMEET_TEST_RECORDING = DOMAIN_MEETING;
export const PEOPLESEARCH = LINK_JITSIMEET + "/peoplesearch";
export const ENABLE_LIVE_CAPTION = env("ENABLE_LIVE_CAPTION");
export const ENABLE_SAVE_CAPTION = env("ENABLE_SAVE_CAPTION");
export const ROLE_MODERATOR = env("ROLE_MODERATOR") || ["host"];
export const HIDDEN_DOMAIN_EMAILS = env("HIDDEN_DOMAIN_EMAILS") || ["@meeting.guest"];
export const RECORDING_DOMAIN = env("RECORDING_DOMAIN", "https://authmeet.atviettelsolutions.com");
export const SERVER_AI_DOMAIN = env("SERVER_AI_DOMAIN") || "https://ai.atviettelsolutions.com";
// export const SOCKET_AI_URL = env("SERVER_AI_DOMAIN") || "https://ai.atviettelsolutions.com";
export const SOCKET_AI_URL = env("SERVER_AI_DOMAIN") || "10.61.185.54:8089";
// export const SOCKET_AI_URL = env("SERVER_AI_DOMAIN") || "vmp-ai-server:8686";
// API
export const GET_ONE_CONFIG = domain + "vmp/config-systems/get-one-config";
export const GET_CONFIGS_SYSTEM = domain + "vmp/config-systems/get-configs";
export const API_MEETING_MANAGEMENT = domain + "home/manager-meeting";
export const PAGE_LOGIN = page + "login";
export const PAGE_MEETING = page + "home/manager-meeting/create";
export const API_AUTHMEETING = domain + "vmp/";
export const API_VMP_LOGIN = domain + "vmp/login";
export const API_VMP_UPDATE_ROOM = domain + "vmp/rooms/update";
export const API_VMP_GET_USER_BY_TOKEN = domain + "vmp/get-user-token";
export const JOIN_NOW = domain + "vmp/rooms/event/room-now";
export const API_VMP_LOGOUT = domain + "vmp/auth/logout";
export const API_GET_ROLE_BY_ROOMID = domain + "vmp/action/get-role";
export const API_UPDATE_BY_ROOMID = domain + "vmp/action/update-all-role/";
export const API_UPDATE_ONE_BY_ROOMID = domain + "vmp/action/update-role/";
export const API_GET_DETAIL_ROOM = domain + "vmp/v1.2/rooms";
export const API_GET_DATA_ATTENDANCE_BY_ROOMID = domain + "vmp/rooms/get-detail/attendance";
// Whiteboard API
export const API_VMP_CHECK_LOGIN_INFO = domain + "vmp/checkLoginInfo/";
export const API_VMP_HAS_SHARING_WB = domain + "api/whiteboard/v1.0/whiteboard-conferences/";
export const API_VMP_POST_WHITEBOARD_CONFERENCE = domain + "api/whiteboard/v1.0/whiteboard-conferences/user-join/";
export const API_WHITEBOARD = domain + "api/whiteboard/v1.0/whiteboards";
// export const API_WHITEBOARD = 'http://localhost:6001/' + "v1.0/whiteboards"
export const API_PERPAGE = "&per_page=15&wb_name=";
// Mobile API
const DOMAIN_MOBILE_VERSION = "https://authmeeting.atviettelsolutions.com/vmp";
//mobile detail mặc định gọi đến authmeeting, không cần sửa môi trường này
export const API_MOBILE_DETAIL = DOMAIN_MOBILE_VERSION + "/mobile-version";
export const API_GET_CONFIG_TIMEOUT = domain + "vmp/config-systems/get-config-timeout";
export const API_UPDATE_STATUS_USER_ON_ROOM = domain + "vmp/rooms/update-status-user/";
export const API_JOIN_GUEST = domain + "vmp/guest-join";
export const API_GUEST_UPDATE_NAME = domain + "vmp/guest-update-name";
export const API_DOMAIN = authDomain + "/vmp/";
const API_MAP = {
    AUTH: {
        REFRESH_TOKEN: API_DOMAIN + "auth/refresh",
        VPQH_SSO: API_DOMAIN + "auth/sso/vpqh"
    },
    ROOM: {
        CHECK_LIMITED_USER: API_DOMAIN + 'checkLimitedUser',
        GET_TOTAL_USERS: API_DOMAIN + 'rooms/get-total-users',
        GET_TOTAL_MEETING: API_DOMAIN + "v1.2/rooms/total-meeting-progress",
        GET_ROLE_ROOM: API_DOMAIN + "rooms/action/get-role-user",
        CHECK_LIMIT_MEETING: API_DOMAIN + "v1.2/rooms/check-limit-meeting",
        GET_LIMIT_USERS: API_DOMAIN + "rooms/action/get-limit-user",
        UPDATE_PASSWORD: API_DOMAIN + "v1.2/rooms/update-password"
    },
    USER: {
        CHECK_GUEST_ACCOUNT: API_DOMAIN + 'check-guest',
        UPDATE_DISPLAYNAME: API_DOMAIN + 'update-displayName',
        GET_USER_FUNCTIONS: API_DOMAIN + 'functions/get/user-functions'
    },
    WHITEBOARD: {
        GET_TOTAL: API_WHITEBOARD + '/get/total'
    },
    CAPTIONS: {
        GET_LIST_SUB: API_DOMAIN + 'live-captions/get-info',
    },
    CASCADE: {
        CHECK_LIMIT: API_DOMAIN + 'cascade/v1.0/session/check-limit'
    }
};
export { API_MAP };
export const URL_POLICY = env("URL_POLICY") || "https://viettelmeet.com/documents/204/dieu-khoan-chinh-sach";
export const VTCLOUD_MARKETPLACE = env('REACT_APP_VTCLOUD_MARKETPLACE') || "https://console.viettelcloud.vn/en/marketplace/products";
